/***
 * Created on 2024/4/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {URLHandler} from "common/ServiceCommon";
import {useBoundedStore} from 'common/Store';
import {getPrimaryQid} from 'common/ServiceUser';

function SigninSwitchAccount(props) {
    const { t } = useTranslation();
    let urlHandler = new URLHandler(window.location.href);
    const [app, setApp] = useState(null);
    const [clientId, setClientId] = useState(urlHandler.clientId);
    const store = useBoundedStore();

    const handleAvatar404 = (e, name) => {
        const parent_element = e.target.parentElement;
        const new_child = document.createElement('span');
        new_child.textContent = name;
        parent_element.appendChild(new_child);
        e.target.remove();
    }

    const getClientId = (url) => {
        urlHandler = new URLHandler(url);
        return urlHandler.clientId;
    }

     const getApp = async () => {
        const resp = await fetch(`/ajax/app/${clientId}`);
        const res = await resp.json();
        setApp(res);
        console.log(res);
    }

    const onContinue = () => {
        let url = new URL(location.href);
        location.href = url.searchParams.get('state');
    }

    const onSignOut = () => {
        urlHandler = new URLHandler(window.location.href);
        location.href = `/signout?next=${urlHandler.convertQueryToNext()}`
    }

    useEffect(() => {
        sessionStorage.clear();
        localStorage.removeItem('currentUser');
        getClientId(window.location.href);
        setClientId(urlHandler.clientId);
        if (clientId) {
            getApp();
        }
    }, [clientId]);

    return (
        <section className="common-page-wrapper common-page-wrapper--sign-in-options">
            <div className="common-page-header">
                <p>{t('@Sign in to QNAP Account@')}</p>
                {
                    app &&
                    <p className="continue-to">{t('@to continue to {app_name}@', {
                        app_name: app.display_name,
                        interpolation: {
                            prefix: '{',
                            suffix: '}',
                            escapeValue: false
                        }
                    })}</p>
                }
            </div>
            <div className="common-page-body">
                <div className="sign-in--options">
                    <div className="common-form-group">
                        <div className="comp-avatar no-avatar">
                             {
                                store?.currentUser?.avatars?.medium && store?.currentUser?.avatars?.medium?.length > 0 &&
                                <img src={store?.currentUser.avatars.medium} alt="avatar"
                                     onError={e => handleAvatar404(e, store?.currentUser?.display_name[0])}/> ||
                                <span>{store?.currentUser?.display_name?.[0]}</span>
                            }
                        </div>
                    </div>
                    <button className="q-btn q-btn--primary--focus btn-medium btn-rounded-normal" onClick={onContinue}>
                        <div className="section-name">
                        {t('@Continue as {Display_Name}@', {
                            Display_Name: store?.currentUser?.display_name,
                            interpolation: {
                                prefix: '{',
                                suffix: '}',
                                escapeValue: false
                            }
                        })}
                        </div>
                        <div className="section-mail">{getPrimaryQid(store?.currentUser?.email)}</div>
                    </button>
                    <button
                        className="q-btn q-btn--default btn-medium btn-rounded-normal mt-16" onClick={onSignOut}>{t('@Log into another account@')}</button>
                    <p className="!mt-20">{t('@If you choose to log into another account, you will be logged out first, then login with another QID account.@')}</p>
                </div>
            </div>
        </section>
);
}

export default SigninSwitchAccount;